import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const { color, radius } = theme;

const columns: CSSObject = {
  display: 'flex',
  flexDirection: 'row',
  gap: '0 16px',
  alignItems: 'stretch',
  [mobile]: {
    flexDirection: 'column',
    gap: 12,
  },
};

const column: CSSObject = {
  flex: 1,
  minWidth: 0,
  border: `1px solid ${color.grey100}`,
  borderRadius: radius.lg,
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
};

const sourceColumn: CSSObject = {
  ...column,
  flex: 1.4,
};

const columnHead: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  marginBottom: 12,
  h4: { fontSize: 15, fontWeight: 700, color: color.text },
};

const tabs: CSSObject = {
  display: 'flex',
  gap: 4,
  marginBottom: 12,
};

const tab = (isActive: boolean): CSSObject => ({
  padding: '8px 14px',
  borderRadius: radius.sm,
  fontSize: 14,
  fontWeight: isActive ? 700 : 500,
  color: isActive ? color.white : color.grey400,
  background: isActive ? color.primary : color.grey75,
  cursor: 'pointer',
});

const panel = (isActive: boolean): CSSObject => ({
  display: isActive ? 'flex' : 'none',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
});

const searchRow: CSSObject = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 6,
  marginBottom: 8,
};

const listWrap: CSSObject = {
  flex: 1,
  minHeight: 360,
  maxHeight: 360,
  overflow: 'auto',
  [mobile]: {
    minHeight: 200,
    maxHeight: 280,
  },
};

/** 선택 목록은 왼쪽 높이에 맞춰 남은 영역 전체를 스크롤한다. */
const selectedScroll: CSSObject = {
  flex: 1,
  position: 'relative',
  minHeight: 360,
  '> ul, > p': {
    position: 'absolute',
    inset: 0,
    overflowY: 'auto',
  },
  [mobile]: {
    minHeight: 280,
  },
};

const selectedEvent: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  padding: '10px 12px',
  marginBottom: 8,
  borderRadius: radius.sm,
  background: color.grey75,
  fontSize: 14,
  strong: { fontWeight: 700 },
};

const bulkRow: CSSObject = {
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: 8,
};

const selectedItem: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0 8px',
  padding: '10px 4px',
  borderBottom: `1px solid ${color.grey75}`,
  fontSize: 14,
};

const removeButton: CSSObject = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 28,
  height: 28,
  borderRadius: radius.sm,
  color: color.grey400,
  cursor: 'pointer',
  lineHeight: 1,
  ':hover': { color: color.error, background: color.errorBg },
};

const empty: CSSObject = {
  padding: '32px 0',
  textAlign: 'center',
  color: color.textMuted,
  fontSize: 14,
};

export {
  columns,
  column,
  sourceColumn,
  columnHead,
  tabs,
  tab,
  panel,
  searchRow,
  listWrap,
  selectedScroll,
  selectedEvent,
  bulkRow,
  selectedItem,
  removeButton,
  empty,
};
